import React, { useReducer } from "react";


const initialState = {
    isSidebarOpen: true,
    activeItem:"Start Page",
    language:"de"
};

function reducer(state, action) {
  switch (action.type) {
    case "setInitialState":
      return { ...state };

    case "toggleSidebar":
      return { ...state, isSidebarOpen: !action.payload };

      case "activeSidebarItem":
          return { ...state, activeItem: action.payload };

      case "toggleLanguage":
          return { ...state, language: action.payload };

    default:
      return { ...state };
  }
}


const StateContext = React.createContext();
const DispatchContext = React.createContext();

function ContextProviderSidebar(props) {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <DispatchContext.Provider value={dispatch}>
      <StateContext.Provider value={state}>
        {props.children}
      </StateContext.Provider>
    </DispatchContext.Provider>
  );
}

export { DispatchContext, StateContext, ContextProviderSidebar };
